import './NotFoundError.less';
import React, { Component } from 'react';
import { AppLocaleProvider, Icon, Layout } from 'sd-ui-components';
import { Link } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { useOidc } from '@axa-fr/react-oidc';
const { Header, Content } = Layout;
const { FormattedMessage } = AppLocaleProvider;

@inject('ConfigStore')
@inject('AuthStore')
@observer
class NotFoundError extends Component {
  componentDidMount() {
    const { isAuthenticated, logout } = useOidc();
    if (!this.props.AuthStore.isAuthenticated) {
      if (isAuthenticated) {
        logout('/');
        this.props.AuthStore.removeStorageForLogout();
      } else {
        this.props.AuthStore.logout();
      }
    }
  }

  render() {
    return (
      <div className="error-root">
        <Layout className="error-layout">
          <Header className="error-header">
            <Icon
              icon="exclampation-circle-o"
              size={73}
              className="error-icon"
            />
          </Header>
          <Content className="error-content">
            <h1 className="error-content-title">
              <FormattedMessage
                id="App.NotFoundError.Title"
                defaultMessage="Oops!"
              />
            </h1>
            <h1 className="error-content-body">
              <FormattedMessage
                id="App.NotFoundError.Subtitle"
                defaultMessage="This page does not exist."
              />
            </h1>
          </Content>
          <Content className="error-body-content sd-primary-background-color-1-fade">
            <div>
              <h3>
                <FormattedMessage
                  id="App.NotFoundError.Body"
                  defaultMessage="But here are a few other pages to try:"
                />
                <ul>
                  <li>
                    <a href={this.props.ConfigStore.config.homeUrl}>
                      <FormattedMessage
                        id="App.NotFoundError.Home"
                        defaultMessage="Home"
                      />
                    </a>
                  </li>
                  <li>
                    <Link to="/safety">
                      <FormattedMessage
                        id="App.NotFoundError.Safety"
                        defaultMessage="Driver safety performance"
                      />
                    </Link>
                  </li>
                </ul>
              </h3>
            </div>
          </Content>
        </Layout>
      </div>
    );
  }
}

export default NotFoundError;



// WEBPACK FOOTER //
// ./src/containers/NotFoundError/NotFoundError.jsx